import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {
  UPDATE_PRODUCTCATEGORY,
  REMOVE_PRODUCTCATEGORY,
} from '../queries/adminQueries';
import { useMutation } from '@apollo/client';

/**
 * ProductCategoryView
 */
const ProductCategoryView = (props: any) => {
  const [categoryname, setCategoryname] = useState<string>(
    props.childPagePropsFromParent.categoryname
  );
  const [isStatusEdit, setIsStatusEdit] = useState<boolean>(false);
  const [isDataChanged, setIsDataChanged] = useState<boolean>(false);
  const [isButtonSaveEnabled, setIsButtonSaveEnabled] =
    useState<boolean>(false);
  const [categoryDeleteDialogVisible, setCategoryDeleteDialogVisible] =
    useState<boolean>(false);

  // update productcategory
  const [updateProductcategory] = useMutation(UPDATE_PRODUCTCATEGORY);

  // delete productcategory
  const [removeProductcategory] = useMutation(REMOVE_PRODUCTCATEGORY, {
    onError: (error) => {
      console.log(
        `Error! ProductcategoryView - removeProductcategory: ${error.message}`
      );
    },
  });

  /**
   * Button Status setzen
   */
  useEffect(() => {
    if (isDataChanged) {
      setIsButtonSaveEnabled(true);
    } else {
      setIsButtonSaveEnabled(false);
    }
  }, [isDataChanged]);

  /**
   * Wenn categoryname geändert wird.
   */
  const handleCategorynameChange = (event: any) => {
    setCategoryname(event.target.value);
    setIsDataChanged(true);
  };

  /**
   * Diese Funktion ändert categoryname.
   */
  const handleProductcategory = async () => {
    try {
      await updateProductcategory({
        variables: {
          id: props.childPagePropsFromParent.id,
          categoryname,
        },
      });
      setIsButtonSaveEnabled(true);
      setIsDataChanged(false);
    } catch (error) {
      console.log('Error! ProductCategoryView - handleProductcategory:', error);
    }
  };

  // return
  return (
    <Container maxWidth='xs'>
      {/** Delete Category Dialog */}
      <Dialog
        open={categoryDeleteDialogVisible}
        onClose={() => setCategoryDeleteDialogVisible(false)}
        aria-labelledby='delete-dialog-title'
        aria-describedby='delete-dialog-description'
      >
        <DialogTitle id='delete-dialog-title'>
          Soll die Warrengruppe gelöscht werden?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='delete-dialog-description'>
            {' "'}
            {categoryname}
            {'" '}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            onClick={() => setCategoryDeleteDialogVisible(false)}
            variant='outlined'
            color='inherit'
          >
            Abbrechen
          </Button>
          <Button
            onClick={() => {
              removeProductcategory({
                variables: { id: props.childPagePropsFromParent.id },
              });
              setCategoryDeleteDialogVisible(false);
              props.sendChildPagePropsToParent({
                page: props.childPagePropsFromParent.page,
                pageSize: props.childPagePropsFromParent.pageSize,
                sortOrder: props.childPagePropsFromParent.sortOrder,
              });
              props.sendChildPageToParent('productCategories');
            }}
            variant='outlined'
            color='inherit'
            autoFocus
          >
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
      {/** Delete Category Dialog end */}
      <Typography component='h2' variant='h6' align='center' mt={2}>
        Warrengruppe
      </Typography>
      <Box mt={2}>
        <TextField
          color='secondary'
          variant='standard'
          required
          sx={{ width: '100%' }}
          label='Warrengruppe'
          autoComplete='off'
          type='text'
          value={categoryname}
          inputProps={{ readOnly: !isStatusEdit }}
          onChange={handleCategorynameChange}
        />
      </Box>
      {isStatusEdit ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            type='submit'
            disabled={!isButtonSaveEnabled}
            sx={{
              marginTop: 3,
              borderRadius: 30,
              width: '240px',
            }}
            variant='contained'
            color='secondary'
            onClick={handleProductcategory}
          >
            Übernehmen
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            type='submit'
            sx={{
              marginTop: 3,
              borderRadius: 30,
              width: '240px',
            }}
            variant='contained'
            color='secondary'
            onClick={() => {
              setIsStatusEdit(true);
              setIsDataChanged(false);
            }}
          >
            Bearbeiten
          </Button>
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          type='submit'
          sx={{
            marginTop: 2,
            borderRadius: 30,
            width: '240px',
          }}
          variant='contained'
          color='secondary'
          onClick={() => setCategoryDeleteDialogVisible(true)}
        >
          Löschen
        </Button>
        <Button
          type='submit'
          sx={{
            marginTop: 2,
            borderRadius: 30,
            width: '240px',
          }}
          variant='contained'
          color='secondary'
          onClick={() => {
            props.sendChildPagePropsToParent({
              page: props.childPagePropsFromParent.page,
              pageSize: props.childPagePropsFromParent.pageSize,
              sortOrder: props.childPagePropsFromParent.sortOrder,
            });
            props.sendChildPageToParent('productCategories');
          }}
        >
          Ok
        </Button>
      </Box>
    </Container>
  );
};

export default ProductCategoryView;
